// extracted by mini-css-extract-plugin
export default {"alignRight":"_bf110d94"};